import { sortMixin } from '@wix/wix-data-items-common';
export class QuerySort extends sortMixin() {
    _build() {
        return this.getSortModel();
    }
}
export function sortBuilderFactory() {
    return new QuerySort();
}
//# sourceMappingURL=sortBuilder.js.map